module.exports = __webpack_public_path__ + "img/ivancik.8799a9d6.jpg";